import { useEffect, useState } from 'react';
import { pb, currentUser } from './lib/pb';
import { setLanguage } from './i18n';
import { setState, useStore } from './store/store';
import { Login } from './Login';
import { Workspace } from './Workspace';

export function App() {
  const user = useStore((s) => s.user);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Refresh a stored session so role changes and revoked accounts take effect.
    const boot = async () => {
      if (pb.authStore.isValid && pb.authStore.record?.collectionName === 'users') {
        try {
          await pb.collection('users').authRefresh();
        } catch {
          pb.authStore.clear();
        }
      } else {
        pb.authStore.clear();
      }
      const u = currentUser();
      if (u?.lang) setLanguage(u.lang);
      setState({ user: u });
      setChecking(false);
    };
    void boot();
    return pb.authStore.onChange(() => setState({ user: currentUser() }));
  }, []);

  if (checking) return <div className="splash" />;
  return user ? <Workspace /> : <Login />;
}
